import setCookie from './setCookie';

export const setFbcCookie = (formattedClickId: string) => {
  return setCookie('_fbc', formattedClickId, 24 * 90); // 90 days, meta recommends 90 days
};
